import StockList from "../components/stock/stock-list.component";

const StockListPage = () => {
  return <StockList />;
};

export default StockListPage;
